import { createTheme } from '@mui/material/styles';
import { typography, radius } from './tokens';

// ─── Responsive Breakpoints ──────────────────────────────────────────────────
//
// lg (1200px)
//   - 사이드바 표시 (lg 미만은 햄버거 메뉴)
//   - Card 1,2 (NU/Seat 총 제공 수량) 범례 세로 배치 (dot+라벨 좌측, 수치 우측)
//   - Card 4 (만료 임박 파트너) chip 아래 배치
//
// xl (1400px)
//   - Card 1,2 범례 가로 배치
//   - Card 4 chip 가로 배치
//
// 상세 가이드 → /docs/RESPONSIVE.md
// ─────────────────────────────────────────────────────────────────────────────
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1400,
    },
  },
  typography: {
    fontFamily: typography.fontFamily,
  },
  shape: {
    borderRadius: radius.base,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;
